<template>
  <div class="aboutus">
    <Header />
    <div class="content">
      <div class="banner">
        <div class="title">
          <span class="zn">关于我们</span>
          <span class="en">About Us</span>
          <span class="line"></span>
          <span>{{ zxTitle }}</span>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" :tab-position="tabPosition" @tab-click="handleClick">
      <el-tab-pane name="first">
        <span slot="label">
          <i class="icon iconfont iconjianjie"></i> 众信简介
        </span>
        <div v-show="isFirst">
          <h3>深圳市众信电子商务交易保障促进中心</h3>
          <div class="text js">
            深圳市众信电子商务交易保障促进中心（ 简称“
            <span>众信中心</span>”
            ）是承担电子商务可信交易环境建设的第三方服务机构。根据目前电子商务市场现状，总结国内企业和第三方机构的成功做法，借鉴国外信用体系建设的先进经验，面向企业提供主体身份在线查验、产品信息在线查验、交易凭证查验、市场基础数据服务等服务，开展电子商务可信交易环境建设宣传与推广。
          </div>
          <div class="clearfix">
            <div class="left text">
              众信中心负责建设和运营电子商务可信交易基础支撑平台“众信网”（www.ebs.org.cn），参与了国家发改委和原工商总局 “电子商务诚信交易服务试点”、原质检总局“电子合同标准研制与应用示范试点”等多个国家及地方试点项目，承担了试点项目成果的应用推广工作。主导和参与了GB/T 31951电子商务信用 网络交易信用主体分类、GB/T
              36314电子商务企业信用档案信息规范等十五项国家标准研制，为电子商务市场提供“验真身”“树好人”“筑诚信”的专业服务，打造可信、可靠、健康、安全的电子商务可信交易生态圈，促进电子商务规范健康发展。
              <!-- <br />
              <br />众信中心负责建设和运营电子商务可信交易基础支撑平台“众信网”(www.ebs.org.cn)
              和电子商务市场公共服务平台（sz.ebs.org.cn）；
              建立电子商务公平竞争、健康经营的规范和标准，打造可信、可靠、健康、安全的电子商务可信交易生态圈，促进电子商务规范健康发展。 -->
            </div>
            <div class="right">
              <img src="./assets/images/aboutus/aq.png" alt />
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane name="second">
        <span slot="label">
          <i class="icon iconfont iconshijianzhou1"></i> 中心大事记
        </span>
        <div v-show="isSecond" class="wrap">
          <div class="btn">
            <a href="javascript:void(0)" @click="jump(item, index)" :class="current === index ? 'active' : ''" v-for="(item, index) in yearList" :key="index + item">{{ item }}</a>
          </div>

          <div class="backtop" v-show="backTop">
            <el-button plain @click="jump(2020, 0)">
              <i class="el-icon-caret-top"></i>返回顶部
            </el-button>
          </div>
          <el-timeline>
            <el-timeline-item color="#d0211f" timestamp="2020年" id="2020" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="5月" placement="top">
              <el-card>
                <h4>
                  分别与惠州市企业诚信促进、佛山市企业信用纠纷人民调解委员会签署战略合作协议，为佛深、深禅两地网络消费纠纷调解、企业信用纠纷调解工作的共同发展掀开了全新的序幕。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>
                  众信ODR平台被国际上最具影响力的ODR组织——美国国家技术与争端解决中心（NCTDR）主动纳入其认可的ODR提供者名录。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>
                  智信+3.0版本上线，该版本整合了以智慧信用为基础的信用服务、验证审核、众信签、众信验证等业务。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="2月" placement="top">
              <el-card>
                <h4>
                  众信签电子合同服务、ODR在线纠纷解决服务、众信推智慧商务名片系统入选深圳市网络办公软件推荐目录（第二批），助力企业高效复产复工。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="1月" placement="top">
              <el-card>
                <h4>
                  跨境电子商务交易保障支撑服务平台荣获“深圳市中小企业公共服务示范平台”。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>
                  网络分级监管平台上线，主要内容包括网络监管主体库、主体信用及风险评级、主体监测、主体预警、违法线索、预警策略等。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2019年" id="2019" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="11月" placement="top">
              <el-card>
                <h4>
                  联合承办“2019智慧园区产业联盟成立大会暨第一次会员大会”。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>
                  牵头起草深圳市地方标准《跨境电子商务在线纠纷解决服务交互规范》，并顺利通过专家评审。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="10月" placement="top">
              <el-card>
                <h4>
                  在深圳市市场监督管理局指导下，举办了2019国际网络营商环境建设论坛暨第二届深圳互联网诚信大会。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>
                  荣获深圳市政法委、中级人民法院、司法局、人社局等多部门联合表彰为“深圳市诉调对接工作先进集体”、“深圳市先进人民调解组织”。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="8月" placement="top">
              <el-card>
                <h4>主办2019第二届中国（深圳）出口跨境电商大会。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="6月" placement="top">
              <el-card>
                <h4>
                  联合深圳众创TV举办2019年“6•16电商企业信用关爱日”走访诚信企业活动。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>
                  与中国报关协会跨境电商分会、联测科技（广州）有限公司共同承办2019国际贸易服务博览会中国跨境电商发展论
                  坛暨第二届中国（广州）跨境电商新生态大会。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>承担中国报关协会跨境电商团体标准工作。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="5月" placement="top">
              <el-card>
                <h4>与深圳市跨境贸易检验认证联盟签订战略协议。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="3月" placement="top">
              <el-card>
                <h4>
                  作为中国电商行业优秀代表，受邀出席2019第二届环球电商峰会并作主题演讲。
                </h4>
                <img src="./assets/images/aboutus/3yue.png" alt />
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="3月" placement="top">
              <el-card>
                <h4>与深圳市互联网学会联合举办2019深圳互联网3•15诚信大会。</h4>
                <img src="./assets/images/aboutus/4yue.png" alt />
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2018年" id="2018" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="11月" placement="top">
              <el-card>
                <h4>与市交委合作共同搭建电子合同在线签订与管理平台。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="10月" placement="top">
              <el-card>
                <h4>主导编制的信用评价相关国家标准在深圳正式发布。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="9月" placement="top">
              <el-card>
                <h4>
                  众信品信通服务全球知名滚动轴承制造企业
                  “斯凯孚集团”开展溯源求真合作。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>众信中心成功举办首届2018中国（深圳）出口跨境电商大会。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp placement="top">
              <el-card>
                <h4>信用评价国家标准在深圳正式发布。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="7月" placement="top">
              <el-card>
                <h4>与深圳贸促会共建企业诚信体系平台。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="4月" placement="top">
              <el-card>
                <h4>众信中心成功举办首届2018深圳国际互联网诚信大会。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2017年" id="2017" placement="top"></el-timeline-item>
            <!-- <el-timeline-item timestamp="8月" placement="top">
              <el-card>
                <h4>
                  众信中心联合企业发起成立“中国企业信用建设发展联盟”，并担任联盟秘书长。
                </h4>
              </el-card>
            </el-timeline-item> -->
            <el-timeline-item timestamp="8月" placement="top">
              <el-card>
                <h4>
                  福田区人民法院授予众信中心为“特邀调解组织”，开启诉调对接新模式。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="6月" placement="top">
              <el-card>
                <h4>
                  众信中心联合电商企业共同网络发布“6.16电商信用关爱日活动”。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="2月" placement="top">
              <el-card>
                <h4>
                  成为国家2017
                  NQI专项“互联网+电子商务领域国际标准研究”牵头单位。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2016年" id="2016" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="11月" placement="top">
              <el-card>
                <h4>参与推进深圳市跨境电子商务综合试验区申报。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="11月" placement="top">
              <el-card>
                <h4>与仲裁委合作共建“互联网+解纷机制”服务，召开专题发布会。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="9月" placement="top">
              <el-card>
                <h4>
                  与腾讯签订合作协议，正式成为微信公众号认证服务全国合作伙伴。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="7月" placement="top">
              <el-card>
                <h4>
                  获批2016国家NQI专项并负责跨境电子商务便利化共性技术标准研究。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="5月" placement="top">
              <el-card>
                <h4>
                  组织深圳市跨境电商企业随时任市委书记马兴瑞赴马来西亚参加深马经贸合作交流会。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="1月" placement="top">
              <el-card>
                <h4>深圳电子商务交易安全工程实验室建成揭牌 。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2015年" id="2015" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="12月" placement="top">
              <el-card>
                <h4>成为WTA国际信赖标章联盟轮值主席单位。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="11月" placement="top">
              <el-card>
                <h4>
                  跨境电子商务交易保障支撑服务系统通过海关总署专家验收并正式启动跨境电商主体身份验证服务。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="6月" placement="top">
              <el-card>
                <h4>
                  获国标委批复成为ISO/TC290国内技术对口单位，电子商务标准化工作方面得到认可。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="5月" placement="top">
              <el-card>
                <h4>承建并运营江苏省工商局“电子商务信用公示平台”。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2014年" id="2014" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="8月" placement="top">
              <el-card>
                <h4>与百度签订“共建互联网诚信环境合作备忘录”。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="4月" placement="top">
              <el-card>
                <h4>与全国组织机构代码证中心合作共建可信交易环境。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2013年" id="2013" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="11月" placement="top">
              <el-card>
                <h4>
                  原工商总局召开现场工作会，全国推广深圳电子商务可信交易环境建设经验。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="10月" placement="top">
              <el-card>
                <h4>
                  电子商务可信交易服务广西贵港市，以“借船出海”，提升影响力。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="4月" placement="top">
              <el-card>
                <h4>
                  电商可信交易环境建设平台
                  “众信网”上线，推出众信验证及在线纠纷解决（ODR）服务。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2012年" id="2012" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="8月" placement="top">
              <el-card>
                <h4>
                  获批国家发改委国家电子商务试点项目
                  “深圳市电子商务诚信交易服务试点”“深圳市电子合同标准研制及应用试点”。
                </h4>
              </el-card>
            </el-timeline-item>
            <!-- <el-timeline-item timestamp="4月" placement="top">
              <el-card>
                <h4>国标委授予深圳“国家电子商务综合标准化示范区”称号。</h4>
              </el-card>
            </el-timeline-item> -->
            <el-timeline-item timestamp="3月" placement="top">
              <el-card>
                <h4>
                  国家、市、区、局领导为众信中心揭牌，与腾讯、阿里巴巴、eBay等知名电商企业签订战略合作。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2011年" id="2011" placement="top"></el-timeline-item>
            <!-- <el-timeline-item timestamp="12月" placement="top">
              <el-card>
                <h4>成为WTA国际信赖标章联盟轮值主席单位。</h4>
              </el-card>
            </el-timeline-item> -->
            <el-timeline-item timestamp="1月-9月" placement="top">
              <el-card>
                <h4>
                  深圳市政府五次办公会议讨论确定深圳率先开展电子商务可信交易环境建设。
                </h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item color="#d0211f" timestamp="2010年" id="2010" placement="top"></el-timeline-item>
            <el-timeline-item timestamp="7月" placement="top">
              <el-card>
                <h4>电子商务企业标准联盟成立。</h4>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="4月" placement="top">
              <el-card>
                <h4>众信中心前身深圳市标准技术研究院电子商务研究所成立。</h4>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-tab-pane>
      <el-tab-pane name="third">
        <span slot="label">
          <i class="icon iconfont iconzuzhijiagou"></i> 组织架构
        </span>
        <div v-show="isThird">
          <h3>组织架构</h3>
          <div class="img">
            <img class="zzjg" src="./assets/images/aboutus/zxjg.jpg" alt />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane name="fourth">
        <span slot="label">
          <i class="icon iconfont iconmokuai"></i> 业务介绍
        </span>
        <div v-show="isFourth">
          <div class="yw-title">1、众信验证服务</div>
          <div class="text em">
            众信验证服务是由第三方公共服务机构推出的为企业或机构提供公信公正、权威可靠、专业规范的经营主体综合实力的验证服务。通过验证的企业或机构借助主体挂标、证书展示及第三方网络公示，可有效防止钓鱼网站仿冒，全面展现综合实力，提升诚信可靠的企业形象。
          </div>
          <div class="yw-title">2、国际电商诚信验证服务</div>
          <div class="text em">
            国际电商诚信验证服务是由权威第三方机构整合国际知名诚信认证机构资源，为全球贸易企业提供信誉度及经营实力的联合验证服务。通过认证企业登记注册、网站安全、经营实景、荣誉资质等信息，多维度、多语种立体展示企业实力，帮助企业快速扩张国际市场，树立阳光诚信的品牌形象。
          </div>
          <div class="yw-title">3、 网监标识备案服务</div>
          <div class="text em">
            网监标识备案服务是根据《网络交易管理办法》(国家工商总局令第60号）规定，从事网络商品交易及有关服务的企业应当根据国家有关规定取得相关证照，并在其经营网页上公开营业执照登载的信息或者其营业执照免费申请的电子链接标识。
          </div>
          <div class="yw-title">4、众信签电子合同服务</div>
          <div class="text em">
            “众信签”提供签约各方身份认证、标准合同模板调用、合同在线起草、在线签署、电子证据保全、在线公证仲裁等在内的一站式电子合同服务。“众信签”，旨在为政府、企业、机构提供具有法律效力的高效便捷、权威公信的“互联网+合同”解决方案，可广泛应用于电子政务、电子商务及金融、房地产、供应链、旅游、教育、物流、交通、制造业、汽车服务等行业，能有效降低运营风险、提高交易效率、降低管理成本。
          </div>
          <div class="yw-title">5、品信通溯源服务</div>
          <div class="text em">
            品信通溯源服务是由权威第三方机构依据相关标准，通过对产商品生产、经营、流通、进出口各环节信息进行采集、验证、传递和管理，实现产商品来源可溯、过程可查、去向可追、真伪可鉴、责任可定。
          </div>
          <div class="yw-title">6、电商知识产权保护与促进服务</div>
          <div class="text em">
            电商知识产权保护与促进服务是为切实帮助电商企业解决复杂的电商知识产权问题，依据知识产权服务国家相关法律和标准，借助互联网新技术，整合全球知识产权服务行业优质资源，以综合服务平台为依托，为电商企业提供知识产权培育指导、风险预警、维权保护、专利价值评估等专业服务。
          </div>
          <div class="yw-title">7、电子商务在线纠纷解决服务</div>
          <div class="text em">
            电子商务在线纠纷解决服务是为了快速解决电子商务交易纠纷，在政府的委托和支持下，联合国内外仲裁机构、消费者组织、行业协会或其他调解组织，依托现代信息技术打造的网络纠纷解决环境，为电商企业及消费者提供一站式纠纷解决服务，主要包括法律咨询、投诉申请、协商和解、调解仲裁等。
          </div>
          <div class="yw-title">8、电子商务信用服务</div>
          <div class="text em">
            电子商务信用服务，是由权威第三方机构，依据相关标准，通过整合政府公共服务、互联网、第三方平台等各方数据，为企业进行信用评价、信用监测与预警的同时，提供包括信用咨询、融资推荐、产业扶持等一站式综合服务。
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane name="five">
        <span slot="label">
          <i class="icon iconfont iconlianxiwomen"></i> 联系我们
        </span>
        <div v-show="isFive" class="call-us">
          <span class="bold">
            <i class="icon iconfont iconrili1"></i>服务时间
          </span>
          <span class="line"></span>
          <span>周一 ~ 周五 &nbsp;&nbsp;&nbsp;&nbsp;09:00-18:00</span>
          <span class="bold">
            <i class="icon iconfont icondizhi"></i>中心地址
          </span>
          <span class="line"></span>
          <span>广东省深圳市福田区深南中路1033号档案大厦</span>
          <div class="mtb">
            <span class="bold">
              <i class="icon iconfont iconkefu"></i>咨询热线
            </span>
            <ul>
              <li><span></span>商务热线：0755-82518112</li>
              <!-- <li><span></span>众信签&众信验证: 0755-82790214</li>
              <li><span></span>微信认证客服电话: 18576409154</li> -->
              <li><span></span>在线纠纷解决(ODR):0755-83262521</li>
            </ul>
            <!-- <ul>
              <li><span></span>品信通防伪溯源： 0755-83951036</li>
              <li><span></span>国际跨境贸易核验服务：0755-83951662</li>
            </ul> -->
          </div>
          <div v-if="map == false" class="map"></div>
          <baidu-map v-else v-loading="loading" class="map" :scroll-wheel-zoom="true" :center="center" :zoom="zoom">
            <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
              <bm-label content="众信中心" :labelStyle="{
                  borderRadius: '6px',
                  color: '#d0211f',
                  fontSize: '18px',
                  padding: '5px',
                }" :offset="{ width: -35, height: 30 }" />
            </bm-marker>
          </baidu-map>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane name="six">
        <span slot="label">
          <i class="icon iconfont iconfuzeren"></i> 负责人简介
        </span>
        <div v-show="issix">
          <h3>负责人简介</h3>
          <div class="flex_box">
            <div class="images_content">
              <img src="@/assets/images/wangke.png" alt="" />
            </div>
            <div class="jianjie">
              <div class="border_red"></div>
              <div class="ml-10">
                <p class="name">王科</p>
                <p class="zhiwu">
                  <span class="line_left"></span><span>理事长</span>
                </p>
                <p>性 别：男</p>
                <p>出生年月：1983年4月</p>
                <p>政治面貌：党员</p>
              </div>
            </div>
          </div>
          <div class="flex_box">
            <div class="images_content">
              <img src="@/assets/images/dujia.png" alt="" />
            </div>
            <div class="jianjie">
              <div class="border_red"></div>
              <div class="ml-10">
                <p class="name">杜佳</p>
                <p class="zhiwu">
                  <span class="line_left"></span><span>副理事长</span>
                </p>
                <p>性 别：女</p>
                <p>出生年月：1976年7月</p>
                <p>政治面貌：党员</p>
              </div>
            </div>
          </div>
          <div class="flex_box">
            <div class="images_content">
              <img src="@/assets/images/zhangxihui.png" alt="" />
            </div>
            <div class="jianjie">
              <div class="border_red"></div>
              <div class="ml-10">
                <p class="name">张喜会</p>
                <p class="zhiwu">
                  <span class="line_left"></span><span>副理事长</span>
                </p>
                <p>性 别：女</p>
                <p>出生年月：1973年6月</p>
                <p>政治面貌：党员</p>
              </div>
            </div>
          </div>
          <div class="flex_box">
            <div class="images_content">
              <img src="@/assets/images/lvyiliang.png" alt="" />
            </div>
            <div class="jianjie">
              <div class="border_red"></div>
              <div class="ml-10">
                <p class="name">吕宜亮</p>
                <p class="zhiwu">
                  <span class="line_left"></span
                  ><span>法定代表人、中心主任</span>
                </p>
                <p>性 别：男</p>
                <p>出生年月：1980年3月</p>
                <p>政治面貌：党员</p>
              </div>
            </div>
          </div>
          <div class="flex_box">
            <div class="images_content">
              <img src="@/assets/images/ouyangsha.png" alt="" />
            </div>
            <div class="jianjie">
              <div class="border_red"></div>
              <div class="ml-10">
                <p class="name">欧阳莎</p>
                <p class="zhiwu">
                  <span class="line_left"></span><span>监事长</span>
                </p>
                <p>性 别：女</p>
                <p>出生年月：1977年4月</p>
                <p>政治面貌：党员</p>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane name="seven">
        <span slot="label">
          <i class="icon iconfont iconzhangcheng"></i> 章程
        </span>
        <div class="isseven" v-show="isseven">
          <h3>章程</h3>
          <div class="mt-20">
            <el-carousel :autoplay="false" height="1150px" :loop="false">
              <el-carousel-item v-for="(item,i) in 10" :key="item">
                <img class="images-w" :src="require('@/assets/images/zc/zhangcheng'+(i+1)+'.png')" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane name="eight">
        <span slot="label">
          <i class="icon iconfont iconzhengshu"></i> 民办非企业登记证书
        </span>
        <div v-show="iseight">
          <h3>民办非企业登记证书</h3>
          <img class="images-w" src="@/assets/images/zhengshu.png" alt="" />
        </div>
      </el-tab-pane> -->
    </el-tabs>

    <Footer />
  </div>
</template>
<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  name: "AboutUs",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tabPosition: "left",
      activeName: "first",
      isFirst: true,
      isSecond: false,
      isThird: false,
      isFourth: false,
      isFive: false,
      issix: false,
      isseven: false,
      iseight: false,
      center: { lng: 0, lat: 0 },
      zoom: 3,
      map: false,
      loading: false,
      yearList: [
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
        "2012",
        "2011",
        "2010",
      ],
      backTop: false,
      current: 0,
      zxTitle: "众信简介",
    };
  },
  methods: {
    handleClick(tab) {
      if (tab.index == 4) {
        this.map = true;
        this.loading = true;
        setTimeout(() => {
          this.center.lng = 114.107347;
          this.center.lat = 22.546367;
          this.zoom = 16;
          this.loading = false;
        }, 500);
      }
      if (tab.name === "first") {
        this.isFirst = true;
        this.isSecond = false;
        this.isThird = false;
        this.isFourth = false;
        this.isFive = false;
        this.zxTitle = "众信简介";
      } else if (tab.name === "second") {
        this.isFirst = false;
        this.isSecond = true;
        this.isThird = false;
        this.isFourth = false;
        this.isFive = false;
        this.zxTitle = "众信大事件";
        window.addEventListener("scroll", this.scrollToTop);
      } else if (tab.name === "third") {
        this.isFirst = false;
        this.isSecond = false;
        this.isThird = true;
        this.isFourth = false;
        this.isFive = false;
        this.zxTitle = "组织架构";
      } else if (tab.name === "fourth") {
        this.isFirst = false;
        this.isSecond = false;
        this.isThird = false;
        this.isFourth = true;
        this.isFive = false;
        this.zxTitle = "业务介绍";
      } else if (tab.name === "five") {
        this.isFirst = false;
        this.isSecond = false;
        this.isThird = false;
        this.isFourth = false;
        this.isFive = true;
        this.zxTitle = "联系我们";
      } else if (tab.name === "six") {
        this.isFirst = false;
        this.isSecond = false;
        this.isThird = false;
        this.isFourth = false;
        this.isFive = false;
        this.issix = true;
        this.zxTitle = "负责人简介";
      } else if (tab.name === "seven") {
        this.isFirst = false;
        this.isSecond = false;
        this.isThird = false;
        this.isFourth = false;
        this.isFive = false;
        this.isseven = true;
        this.zxTitle = "章程";
      } else if (tab.name === "eight") {
        this.isFirst = false;
        this.isSecond = false;
        this.isThird = false;
        this.isFourth = false;
        this.isFive = false;
        this.iseight = true;
        this.zxTitle = "民办非企业登记证书";
      }
    },
    jump(domId, index) {
      let jump = document.getElementById(domId);
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      this.current = index;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      // 获取当前滚动条与窗体顶部的距离
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      total > 86 ? (this.backTop = true) : (this.backTop = false);
      // 计算每一小段的距离
      let step = total / 50;
      (function smoothDown() {
        if (distance < total) {
          distance += step; // 移动一小段
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance; // 设定每一次跳动的时间间隔为10ms
          setTimeout(smoothDown, 10);
        } else {
          // 限制滚动停止时的距离
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      })();
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 550) {
        this.backTop = true;
      } else {
        this.backTop = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.aboutus {
  .map {
    width: 100%;
    height: 300px;
    box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.2);
  }
  .btn {
    margin-bottom: 60px;
    a {
      width: 55px;
      line-height: 24px;
      height: 24px;
      text-align: center;
      display: inline-block;
      border-radius: 4px;
      border: solid 1px #eeeeee;
      color: #666;
      margin-right: 10px;
      cursor: pointer;
      &.active {
        background: #d0211f;
        color: #fff;
      }
      &:hover {
        background: #d0211f;
        color: #fff;
      }
    }
  }
  .content {
    margin-top: 60px;
    .banner {
      width: 100%;
      height: 200px;
      background: url("./assets/images/banner/banner.png") no-repeat;
      .title {
        width: 1040px;
        margin: 0 auto;
        padding-top: 80px;
        span {
          color: #2d313d;
          &.zn {
            font-size: 24px;
            font-weight: bold;
            margin-right: 20px;
          }
          &.en {
            font-size: 24px;
          }
          &.line {
            display: block;
            width: 22px;
            height: 8px;
            margin: 13px 0 20px;
            background-color: #d0211f;
          }
        }
      }
    }
  }
  .flex_box {
    display: flex;
    margin-top: 20px;
    .jianjie {
      flex: 1;
      border: solid 1px #f5f5f5;
      margin-left: 20px;
      box-sizing: border-box;
      height: 300px;
      border-radius: 2px;
      p {
        line-height: 34px;
      }
      .ml-10 {
        margin-left: 30px;
      }
      .name {
        margin-top: 20px;
        color: #d0211f;
        font-size: 28px;
        font-weight: 700;
      }
      .zhiwu {
        display: flex;
        margin-top: 8px;
        .line_left {
          display: inline-block;
          height: 18px;
          line-height: 18px;
          width: 4px;
          background-color: #d0211f;
          margin-top: 8px;
          margin-right: 10px;
        }
        // padding-left: 10px;
      }
    }
    .border_red {
      height: 6px;
      width: 100%;
      background-color: #d0211f;
    }
  }
  .images-w {
    width: 100%;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .el-tabs {
    width: 1040px;
    margin: 30px auto 80px;
    position: relative;
    .zzjg {
      width: 100%;
      height: 100%;
    }
    /deep/.el-tabs__item {
      width: 185px;
      text-align: left;
      line-height: 40px;
      margin-bottom: 15px;
      background-color: #ffffff;
      box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.2);
      border: solid 1px #eeeeee;
      color: #333;
      &.is-active {
        color: #fff;
        background-color: #d0211f;
      }
    }
    /deep/.el-tabs__active-bar {
      background-color: transparent;
    }
    /deep/.el-tabs__nav-wrap::after {
      display: none;
    }
    /deep/.el-tabs__content {
      padding-left: 40px;
      .wrap {
        .backtop {
          position: fixed;
          right: 200px;
          bottom: 100px;
          z-index: 99;
        }
        .el-timeline {
          width: 800px;
          .el-card {
            img {
              width: 100%;
            }
          }
          li[id^="20"] {
            .is-top {
              color: #d0211f;
              font-weight: bold;
              font-size: 20px;
              padding-top: 0;
            }
          }
        }
      }
      h3 {
        font-size: 24px;
        color: #333;
        padding-bottom: 20px;
        border-bottom: 6px solid #eee;
      }
      .js {
        margin: 30px 0 20px;
      }
      .img {
        margin: 40px auto;
        text-align: center;
      }
      .text {
        font-size: 14px;
        color: #666;
        line-height: 28px;
        span {
          color: #333;
          font-weight: 900;
        }
      }
      .em {
        text-indent: 2em;
      }
      .yw-title {
        color: #de252d;
        font-weight: bold;
        margin-top: 25px;
        margin-bottom: 10px;
        font-size: 15px;
      }
      .left {
        width: 60%;
        display: inline-block;
        float: left;
      }
      .right {
        float: right;
        width: 30%;
        display: inline-block;
        img {
          width: 100%;
        }
      }
      .call-us {
        border-radius: 4px;
        border: solid 1px #eeeeee;
        padding: 16px;
        span {
          color: #666;
          i {
            margin-right: 8px;
            &.icondizhi {
              margin-left: 25px;
            }
          }
          &.bold {
            color: #333;
            font-weight: bold;
          }
          &.line {
            width: 2px;
            height: 14px;
            display: inline-block;
            background: #d0211f;
            margin: 0 15px;
            vertical-align: middle;
          }
        }
        .mtb {
          border-top: 2px dashed #eee;
          margin-top: 20px;
          margin-bottom: 40px;
          padding-top: 20px;
          ul {
            margin-top: 20px;
            li {
              color: #666;
              width: 31%;
              display: inline-block;
              span {
                width: 6px;
                height: 6px;
                display: inline-block;
                background-color: #d0211f;
                vertical-align: middle;
                margin-right: 10px;
              }
              &:last-child {
                width: 37%;
              }
            }
          }
        }
      }
    }
  }
}
</style>